export class ImageHelper {
  static isImage(extension: string): boolean {
    const imagetypes: string[] = ['jpg', 'bmp', 'png', 'gif', 'img', 'jpeg'];
    return (imagetypes.indexOf(extension) > -1);
  }

  static isFileImage(filename: string): boolean {
    const index = filename.lastIndexOf('.') + 1;
    if (index < 0 || index >= filename.length) {
      return false;
    }
    return this.isImage(filename.substring(index).toLowerCase());
  }
}
